import { Button } from '@design-system/Button';
import React from 'react';
import { SummaryContainer } from '../style';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';

const Summary = ({ total, handleNavigate }) => {
  return (
    <SummaryContainer>
      <div className="total">
        <h4>Total</h4>
        <h3>₦{commaNumber(total)}</h3>
      </div>

      <div className="sub_total">
        <h4>
          Subtotal <strong>(excl.delivery)</strong>
        </h4>
        <h3>₦{commaNumber(total)}</h3>
      </div>

      <div className="button">
        <Button
          onClick={handleNavigate}
          text={'Proceed to Delivery'}
          bgColor="#549A9A"
          width="100%"
        />
      </div>
    </SummaryContainer>
  );
};

export default Summary;

Summary.propTypes = {
  total: PropTypes.number.isRequired,
  handleNavigate: PropTypes.func,
};

Summary.defaultProps = {
  handleNavigate: () => {},
};
